import * as React from "react";
import {connect} from "react-redux";
import {withRouter, Link} from "react-router-dom";
import {RouteComponentProps} from "react-router-dom";
import {ListGroup, ListGroupItem, Button, Table} from "react-bootstrap";
import {indexOf, map, isEmpty, size} from "lodash";
import "react-dates/lib/css/_datepicker.css";
import "font-awesome/less/font-awesome.less";
import "hint.css/hint.css";

import {HotelAction, updateOrder} from "../actions/hotels";
import {ApplicationState} from "../reducers";
import "./styles/hotels.less";
import {destinationLabel, Search} from "../models/hotels";
import {TicketMap} from "../reducers/config";
import {Order, OrderHotel, OrderTicket} from "../models/order";
import {LOCAL_DATE_FMT} from "../utils";

interface ActionProps {
    updateOrder: (order: Order) => Promise<HotelAction>;
}

interface Props extends ActionProps, RouteComponentProps<any> {
    order: Order;
    search: Search;
    tickets: TicketMap;
    loading: boolean;
}

class Cart extends React.Component<Props> {
    public render(): JSX.Element {
        return this.renderCart();
    }

    public renderCart(): JSX.Element {
        if (!this.props.order || isEmpty(this.props.tickets)) {
            return null;
        }

        const isReadOnly = this.isReadOnlyURL();

        let hotels = null;
        if (!isEmpty(this.props.order.hotel)) {
            hotels = (
                <Table striped hover className="cart-hotels">
                    <thead>
                    <tr>
                        <th>Hotel</th>
                        <th>Dates</th>
                        <th>Occupants</th>
                        <th/>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        map(this.props.order.hotel, (orderHotel, index) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <Link to={`/hotels/${orderHotel.hotelId}`}>{orderHotel.hotelTitle}</Link>
                                        <br />{orderHotel.roomTitle}
                                    </td>
                                    <td>
                                        <div>
                                            <label>Check-in</label>
                                            <div>{orderHotel.checkIn.format(LOCAL_DATE_FMT)}</div>
                                        </div>
                                        <div>
                                            <label>Check-out</label>
                                            <div>{orderHotel.checkOut.format(LOCAL_DATE_FMT)}</div>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <label>Adults</label>
                                            <div>{orderHotel.numAdults}</div>
                                        </div>
                                        <div>
                                            <label>Children</label>
                                            <div>{size(orderHotel.childAges)}</div>
                                        </div>
                                    </td>
                                    <td className="actions">
                                        {isReadOnly || <Button className="hint--bottom"
                                                onClick={() => this.removeHotel(orderHotel)}
                                                aria-label="Remove Hotel">
                                            <i className="fa fa-remove" />
                                        </Button>}
                                    </td>
                                </tr>
                            );
                        })
                    }
                    </tbody>
                </Table>
            );
        }

        let tickets = (
            <ListGroup>
                <ListGroupItem>Your order has no tickets</ListGroupItem>
            </ListGroup>
        );
        if (!isEmpty(this.props.order.tickets)) {
            tickets = (
                <Table striped hover>
                    <thead>
                    <tr>
                        <th>Ticket</th>
                        <th># Adults</th>
                        <th># Children</th>
                        <th>First Day</th>
                        <th/>
                    </tr>
                    </thead>
                    <tbody>
                    {map(this.props.order.tickets, (orderTicket, index) => {
                        const ticket = this.props.tickets[orderTicket.ticketId];
                        return (
                            <tr key={index}>
                                <td>{destinationLabel(ticket.destination)} {ticket.days}-Day {ticket.name}</td>
                                <td>{orderTicket.quantityAdults}</td>
                                <td>{orderTicket.quantityChildren}</td>
                                <td>{orderTicket.firstDate}</td>
                                <td className="actions">
                                    {isReadOnly || <Button className="hint--bottom"
                                            onClick={() => this.removeTicket(orderTicket)}
                                            aria-label="Remove Ticket">
                                        <i className="fa fa-remove" />
                                    </Button>}
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </Table>
            );
        }

        return (
            <div>
                {tickets}
            </div>
        );
    }

    private removeTicket(ticket: OrderTicket) {
        if (this.isReadOnlyURL()) {
            return;
        }
        const order = this.props.order;
        const index = indexOf(order.tickets, ticket);
        if (index > -1) {
            order.tickets.splice(index, 1);
        }
        order.ticketsSelected = true;
        this.props.updateOrder(order);
    }

    private removeHotel(hotel: OrderHotel) {
        if (this.isReadOnlyURL()) {
            return;
        }
        const order = this.props.order;
        const index = indexOf(order.hotel, hotel);
        if (index > -1) {
            order.hotel.splice(index, 1);
        }
        this.props.updateOrder(order);
    }

    private isReadOnlyURL(): boolean {
        return this.props.location.pathname.indexOf("checkout") > -1 ||
            this.props.location.pathname.indexOf("review") > -1 ||
            this.props.location.pathname.indexOf("summary") > -1;
    }
}

const connected = connect((state: ApplicationState) => ({
    order: state.hotels.order,
    search: state.hotels.searchCriteria,
    tickets: state.config.tickets,
    loading: state.hotels.loading || state.hotels.orderLoading || state.hotels.searchLoading
}), {
    updateOrder
})(Cart);

export default withRouter<any>(connected);



// WEBPACK FOOTER //
// ./src/components/Cart.tsx